// The followinng numbers repersent a specific type in the backend. Hence, why they are 1 and 2.

export enum JobAttachmentTypes {
    File = 1,
    Text = 2,
}
